import { AccordionSummary, Typography, useTheme } from '@mui/material';
import { Icon24Chevron } from '@care/react-embrace-icons';
import { Icon24UtilityChevron } from '@care/react-icons';

import useResponsive from '@/components/hooks/useResponsive';
import useTestFlags from '@/components/hooks/useTestFlags';

const AccordionContent = ({ title }: { title: string }) => {
  const theme = useTheme();
  const { isDesktop } = useResponsive();
  const { greaterCare } = useTestFlags();
  const isGreaterCare = greaterCare?.value === 1;

  const IconChevron = isGreaterCare ? Icon24Chevron : Icon24UtilityChevron;

  const defaultColor = isDesktop ? theme.palette.text.secondary : theme.palette.text.primary;

  return (
    <AccordionSummary
      sx={{
        width: { md: 'fit-content' },
        padding: { md: 0 },
      }}
      expandIcon={
        <IconChevron
          sx={{
            ml: 0.5,
          }}
          color={isGreaterCare ? theme.palette.text.brandInverse : defaultColor}
        />
      }>
      <Typography
        variant={isDesktop ? 'h4' : 'h3'}
        color={isGreaterCare ? theme.palette.text.brandInverse : defaultColor}>
        {title}
      </Typography>
    </AccordionSummary>
  );
};

export default AccordionContent;
